"use client";

import { Marquee } from "@/app/components/marquee";
import { m, useInView } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";

interface Props {
  data?: any;
}

const itemVariants = {
  initial: { opacity: 0, y: 32 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      type: "spring",
    },
  },
};

function Content({ data }: any) {
  return (
    <>
      {data?.logos?.map((item: any, index: number) => (
        <m.div
          key={index}
          className="relative frame aspect-square w-32 sm:w-40 md:w-48 lg:w-64 flex items-center justify-center p-4"
        >
          {item?.asset?.url && (
            <Image
              src={item.asset.url}
              alt={item?.alt ?? "Client logo"}
              width={200}
              height={200}
              sizes="(min-width: 1024px) 256px, (min-width: 768px) 192px, (min-width: 640px) 160px, 128px"
              className="max-w-44 max-h-28 w-full w-full h-full object-contain"
            />
          )}
        </m.div>
      ))}
    </>
  );
}
export default function LogosCarousel({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
  });
  return (
    <m.section
      transition={{ staggerChildren: 0.05, delayChildren: 0.2 }}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
      ref={ref}
      variants={itemVariants}
      className={`${data?.paddingBottom ? "pb-20" : ""} overflow-hidden`}
    >
      <Marquee className="py-4">
        <Content data={data} />
        <Content data={data} />
      </Marquee>
    </m.section>
  );
}
